import { useNavigate, useParams } from "react-router-dom";
import React, { useLayoutEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ChannelStreamCard } from "../ChannelStreamCard/channelStreamCard";
import { StremioStream } from "../../../../apis/towers-sports-api/types";
import users from "../../../users";
import useScrollContainerRef from "../../movies/utils/useScrollContainerRef";
import { Spinner, ExpandableSearchInput, CustomSelectorV2 } from "../../../shared";
import { cn } from "../../../../utils/utils";
import { Helmet } from "react-helmet";
import ButtonV2 from "../../../shared/button-v2/button-v2";
import { StremioChannelsRow } from "../../squadflixHome/rows/StremioChannelsRow";
import CachedImage from "../../../shared/cached-image/cached-image";

import './squadflixLiveChannelDetails.scss';
import useLiveChannelDetailsData from "../../hooks/useLiveChannelDetailsData";

export const SquadflixLiveChannelDetails = () => {
    const id = useParams().id;
    const {
        channel,
        filteredStreams,
        providers,
        search,
        setSearch,
        selectedProvider,
        setSelectedProvider,
        channelViewers,
        getStreamViewers,
        loading
    } = useLiveChannelDetailsData(id);
    const darkTheme = useSelector(users.selectors.isDarkMode);
    const parentRef = useScrollContainerRef();
    const [backdropOpacity, setBackdropOpacity] = useState(0);
    const containerRef = React.createRef<HTMLDivElement>();
    const backgroundAspectRatio = 9 / 16;
    const navigate = useNavigate();

    useLayoutEffect(() => {
        if (!parentRef.ref) {
            return;
        }

        parentRef.ref.current.addEventListener("scroll", () => {
            const scrollTop = parentRef.ref.current.scrollTop;
            const newOpacity = Math.min(scrollTop / 300, 0.6);
            setBackdropOpacity(newOpacity);
        });
    }, [parentRef.ref]);

    const handleClickStream = (stream: StremioStream) => {
        navigate(`/squadflix/live/channel/${id}/stream/${stream.hash}`);
    }

    if (loading) {
        return <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
            <Spinner />
        </div>;
    }

    return (
        <div className={cn("serie-details", { "serie-details-dark": darkTheme })} ref={containerRef}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{channel.name}</title>
                <link rel="icon"
                    href="https://torresowo.myftp.org/web/cap17an/cap17drive/imagenes/Icono-Cap17Drive.png" />
            </Helmet>
            <div className="serie-details__top-header" style={{
                backgroundColor: backdropOpacity > 0.55 ? (darkTheme ? "rgb(33,37,41)" : "white") : "transparent",
                width: parentRef.width,
            }}>
                <ButtonV2
                    className="serie-details__back-button"
                    width={"50px"}
                    onClick={() => {
                        navigate('/squadflix/live/');
                    }}>
                    <i className={cn("fa-solid fa-chevron-left fa-lg")}></i>
                </ButtonV2>
                {backdropOpacity > 0.55 && <div className="serie-details__top-header-title">{channel.name}</div>}
            </div>
            <div style={{
                position: "relative",
                zIndex: 2,
                width: "100%",
            }}>
                <div className="serie-details__header" style={{
                    minHeight: (parentRef.width * backgroundAspectRatio) - 160,
                }}>
                    <div className="serie-details__header--title-placeholder">
                        {channel.name}</div>
                    <div className="serie-details__header--info text-muted">
                        <span>{channel.streams} enlaces</span>&nbsp;·&nbsp;<span>{channelViewers} <i className="fa-solid fa-eye"></i></span>
                    </div>
                    <div className="serie-details__header--overview">
                    </div>
                    <div className="serie-details__header--actions">
                    </div>
                </div>
                <div className="serie-details__content" style={{
                    marginTop: -40,
                    paddingTop: 0,
                    position: "relative",
                    zIndex: 3,
                }}>
                    <div className="serie-details__content--filters"
                        style={{
                            display: 'flex', justifyContent: 'flex-end',
                            gap: '15px', marginBottom: '15px', flexWrap: 'wrap',
                            position: 'relative', zIndex: 2,
                        }}>
                        <div style={{
                            minWidth: 50,
                        }}>
                            <ExpandableSearchInput
                                value={search}
                                onChange={(val) => setSearch(val)}
                                placeholder="Buscar enlaces"
                                expandedWidth="300px"
                            />
                        </div>
                        <CustomSelectorV2
                            value={selectedProvider}
                            onChange={(val) => setSelectedProvider(val)}
                            icon="fa-solid fa-filter"
                            options={providers}
                            width="250px"
                            placeholder="Todos los proveedores"
                        />
                    </div>
                    <div style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                        gap: "15px",
                        marginBottom: "30px",
                    }}>
                        {filteredStreams.map((stream, index) => (
                            <ChannelStreamCard onClick={handleClickStream} key={index} stream={stream} activeViewers={getStreamViewers(stream.hash)} />
                        ))}
                    </div>
                    <StremioChannelsRow hideIds={[id]} />
                </div>
            </div>
            <div
                className="serie-details__background-image"
                style={{
                    width: parentRef.width - 2,
                    height: parentRef.width * backgroundAspectRatio,
                }}>
                <div className="serie-details__background-image--backdrop" style={{
                    opacity: backdropOpacity,
                }}></div>
                <div className="serie-details__background-image--overlay"></div>
                {channel.background && <CachedImage
                    className="serie-details__background-image--still"
                    src={channel.background} />}
            </div>
        </div>
    );
}
